import React from 'react';
import classnames from 'classnames';

import styles from './css/NewUserSignup.module.css';


function CheckEmailMessage({ dismissMessage }) {
  return (
    <div className={styles.signupMessage}>
      <div className={styles.newUserSignup}>
        <h1 className={styles.textBlue}>
          Check Your Email to Activate!
        </h1>
        <p className={styles.paragraph}>
          You will receive an email from us at info@apps.nakednews.com. Please click the 'Activate Your Account' button in your email to activate your <b>free access account.</b>
        </p>
        <button className={classnames(styles.btnCurvedRed, styles.mt5)} onClick={dismissMessage}>Go back</button>
      </div>
    </div>
  );
}

export default CheckEmailMessage;
